import { useEffect, useState } from 'react'
import { useAuth } from 'context/user'
import { graphqlRequest } from 'lib/helpers'
import { Connection } from 'types/api'
import listMyConnectionsQuery from 'graphql/listMyConnections.graphql'

export const useTwitchConnection = (): {
  connected: boolean
  login: string | null
  displayName: string | null
} => {
  const { auth0Token } = useAuth()
  const [connected, setConnected] = useState(false)
  const [login, setLogin] = useState<string | null>(null)
  const [displayName, setDisplayName] = useState<string | null>(null)

  useEffect(() => {
    if (auth0Token === undefined) return
    let cancelled = false
    const load = async (): Promise<void> => {
      try {
        const resp = await graphqlRequest<{ connections: Connection[] }>(
          listMyConnectionsQuery, {}, auth0Token
        )
        if (cancelled) return
        const twitch = (resp.connections ?? []).find((c) => c.provider === 'twitch')
        const usable = twitch !== undefined && twitch.status === 'connected'
        setConnected(usable)
        setLogin(usable ? (twitch.login ?? null) : null)
        setDisplayName(usable ? (twitch.displayName ?? null) : null)
      } catch {
      }
    }
    void load()
    return () => { cancelled = true }
  }, [auth0Token])

  return { connected, login, displayName }
}
